import React from 'react';
import PropTypes from 'prop-types';

const ModalHeader = ({ dispatch, handleClose, updatedFiltersData }) => (
  <div className="modal__header">
    <div className="header-copy-container">
      <h2 className="modal-title">{t("Manage Pinned Searches")}</h2>
      <h4 className="modal-subtitle">
        {t("Create, rename, reorder, or delete pinned searches")}
      </h4>
    </div>
    <button
      className="button secondary alphabetize-button"
      disabled={!updatedFiltersData.length}
      onClick={() => dispatch({ type: 'alphabetize' })}
      type="button"
    >
      {t("Alphabetize")}
    </button>
    <button
      className="close-button"
      onClick={() => handleClose()}
      type="button"
    >
      <span className="bff-close" />
    </button>
  </div>
);

ModalHeader.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  updatedFiltersData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ModalHeader;
